import React from 'react'
import { Link } from 'react-router-dom'
import pageWindow from '../functions/pageWindow'
import { LABELS } from '../constants/staticText'

// Der Name des Seitenparameters in der Adresse — eine Stelle fuer Leiste und Liste.
export const SEITE = 'seite'

// Seitenleiste der Stellenliste (#223): der Server liefert 20 Anzeigen je
// Seite, die Seite steht in der Adresse (?seite=N), damit ein Verweis teilbar
// und fuer Suchmaschinen erreichbar bleibt. Die uebrigen Parameter (Firma)
// bleiben in jedem Verweis erhalten.
//
// Nicht ?page=N: page ist eine Abfragevariable von WordPress (Seite N eines
// Beitrags), und redirect_canonical leitet jede Adresse damit per 301 auf die
// Liste ohne Parameter um. Ein Klick in der App ging (Router), ein Verweis,
// Lesezeichen oder Crawler landete immer auf Seite 1.
//
// Jeder Verweis traegt SEITENWECHSEL im Router-Zustand: daran erkennt die
// Liste, dass der Fokus an ihren Anfang gehoert — der angeklickte Verweis
// verschwindet ja (#236). Eine neue Suche setzt die Seite ohne ihn zurueck.
const SEITENWECHSEL = { seitenwechsel: true }

const JobsPager = ({ page, total, pageSize, searchParams }) => {
    const seiten = Math.ceil(total / pageSize)
    if (seiten < 2) return null

    const ziel = (seite) => {
        const params = new URLSearchParams(searchParams)
        if (seite > 1) params.set(SEITE, String(seite))
        else params.delete(SEITE)
        const suche = params.toString()
        return `/stellenangebote/${suche ? `?${suche}` : ''}`
    }

    return (
        <nav className="jobs-pager" aria-label={LABELS.pager}>
            <ul className="jobs-pager-list">
                {page > 1 && (
                    <li className="jobs-pager-step">
                        <Link to={ziel(page - 1)} state={SEITENWECHSEL} rel="prev">{LABELS.pagerPrev}</Link>
                    </li>
                )}
                {pageWindow(page, seiten).map((seite, index) => (
                    <li key={seite === null ? `luecke-${index}` : seite}>
                        {seite === null && <span className="jobs-pager-gap" aria-hidden="true">…</span>}
                        {seite === page && <span className="jobs-pager-current" aria-current="page">{seite}</span>}
                        {seite !== null && seite !== page && (
                            <Link to={ziel(seite)} state={SEITENWECHSEL} aria-label={`${LABELS.pagerPage} ${seite}`}>{seite}</Link>
                        )}
                    </li>
                ))}
                {page < seiten && (
                    <li className="jobs-pager-step">
                        <Link to={ziel(page + 1)} state={SEITENWECHSEL} rel="next">{LABELS.pagerNext}</Link>
                    </li>
                )}
            </ul>
        </nav>
    )
}

export default JobsPager
